import { forwardRef } from 'react'
import { ButtonStyled, ButtonLoader } from './styled'

const Button = forwardRef(
  (
    {
      theme = 'base',
      size = 'large',
      minWidth,
      title,
      onClick,
      icon,
      loading = '',
      attrTitle,
      ...props
    },
    ref
  ) => (
    <ButtonStyled
      $theme={theme}
      $size={size}
      $minWidth={minWidth}
      onClick={onClick}
      $loading={String(loading)}
      title={attrTitle}
      ref={ref}
      {...props}
    >
      {icon && icon}
      {loading && <ButtonLoader />}
      {title && <span>{title}</span>}
    </ButtonStyled>
  )
)

export default Button

Button.displayName = 'Button'
